import * as React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ReCAPTCHA from "react-google-recaptcha";
import { Alert, Button, Stack, Text, TextInput } from "@mantine/core";
import * as authActions from "../../data/actions/authenticationActions";
import AuthApi from "../../data/api/authApi";
import { CenteredLoader } from "../common/loader";

interface ILoginFormProps {
  actions: any;
}

interface ILoginFormState {
  username: string;
  successMessage?: string;
  error?: string | null;
  loading?: boolean;
  captchaRef: React.Ref<ReCAPTCHA>;
}

class TriggerResetPasswordForm extends React.PureComponent<
  ILoginFormProps,
  ILoginFormState
> {
  constructor(props, content) {
    super(props, content);
    this.state = {
      username: "", // if we could find the previous user from storage
      captchaRef: React.createRef(),
      loading: false,
    };

    this.onChange = this.onChange.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.onReceivedCaptcha = this.onReceivedCaptcha.bind(this);
  }

  onChange(event) {
    if (!this.state) return;
    const ct = event.currentTarget;
    this.setState((state) => ({ ...state, [ct.name]: ct.value }));
  }

  resetButtonClicked(event) {
    event.preventDefault();
    this.setState({ loading: true, error: null });
    // @ts-ignore
    this.state.captchaRef.current.execute();
  }

  onReceivedCaptcha(token) {
    AuthApi.triggerAnonPasswordReset(this.state.username, token)
      .then((message) =>
        this.setState((state) => ({
          ...state,
          loading: false,
          successMessage: message,
        })),
      )
      .catch((er) =>
        this.setState((state) => ({
          ...state,
          loading: false,
          error: er.message,
        })),
      );
  }

  render() {
    const { error, loading, successMessage } = this.state;

    if (successMessage) return <Alert color="green">{successMessage}</Alert>;

    return (
      <form
        onSubmit={this.resetButtonClicked}
        style={{ overflow: "hidden" }}
      >
        <Stack gap="md">
          {error && <Alert color="red">{error}</Alert>}
          <TextInput
            label="Username"
            name="username"
            autoComplete="username"
            value={this.state.username}
            onChange={this.onChange}
            disabled={loading}
            styles={{
              label: { color: "var(--color-text-medium)" }
            }}
          />

          <ReCAPTCHA
            ref={this.state.captchaRef}
            size="invisible"
            // Developer Key
            // sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
            // Production:
            sitekey="6LeCHqoUAAAAAGzJfau63WbKuzYXPiolulT2Jfce"
            onChange={this.onReceivedCaptcha}
          />

          {/* https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge-what-is-allowed */}
          <p style={{ color: "darkgray" }}>
            This site is protected by reCAPTCHA and the Google{" "}
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
            <a href="https://policies.google.com/terms">Terms of Service</a>{" "}
            apply.
          </p>
          {error && !loading && <p className="text-danger">{error}</p>}
          {loading && <CenteredLoader />}
          <Button
            type="submit"
            fullWidth
            disabled={loading}
            onClick={this.resetButtonClicked}
          >
            Reset
          </Button>
        </Stack>
      </form>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(authActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(TriggerResetPasswordForm);
